export const ROUTES = {
  ADMIN: '/admin',
  ACCOUNT: '/account', // Deprecated
  ACCOUNT_EVENTS: '/account/events',
  ACCOUNT_HELP: '/account/help',
  ACCOUNT_ORDERS: '/account/orders',
  ACCOUNT_USER: '/account/user',
  EVENT: '/event',
  ACCOUNT_CONNECTORS: '/account/connectors',

  // Route names
  LOGIN: 'login',
  REGISTER: 'register',
  PRIVACY_POLICY: 'privacy-policy',
  TERMS_AND_CONDITIONS: 'terms-and-conditions',
  FORGOT_PASSWORD: 'reset-password',
  EVENT_ORDER: 'order',
  EVENT_DEMO_ORDER: 'order-demo',
  PRICES: 'prices',
  ABOUT: 'about',
  HELP_FAQ: 'faq',
  HOW_IT_WORKS: 'how-it-works',
  REVIEWS: 'reviews',
  CONTACT: 'contact',
  BLOG: 'blog',
}
